import { MealBuilderMenuSection } from '@/models';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

interface MobileNavUILink {    
  id: number,
  title: string,
  elementRef: HTMLElement,
  analyticsName: string
}

interface AnalyticsName {
  name: string,
  subStrings: string[],
  exclude?: string[]
}

const AnalyticsNames: AnalyticsName[] = [
  {
    name: 'protein-or-veggie',
    subStrings: ['protein', 'veggie', 'protein or veggie']
  },
  {
    name: 'rice',
    subStrings: ['rice']
  },
  {
    name: 'beans',
    subStrings: ['beans']
  },
  {
    name: 'toppings',
    subStrings: ['top things off', 'toppings'],
    exclude: ['included']
  },
  {
    name: 'included-toppings',
    subStrings: ['included toppings']
  },
  {
    name: 'options',
    subStrings: ['options']
  },
  {
    name: 'tortilla',
    subStrings: ['tortilla']
  },
  {
    name: 'side',
    subStrings: ['side'],
    exclude: ['add-on', 'always', 'included']
  },
  {
    name: 'desserts',
    subStrings: ['dessert']
  },
  {
    name: 'drinks',
    subStrings: ['drink']
  },
  {
    name: 'add-ons',
    subStrings: ['add-ons']
  },
  {
    name: 'included-sides',
    subStrings: ['included sides']
  }
]

@Component({
    name: 'CmgMealBuilderMobileNav',
})
export default class CmgMealBuilderMobileNav extends Vue {    
  @Prop({ required: true, type: Array })
  navLinks!: MealBuilderMenuSection[];

  @Prop({ required: true, type: Number})
  navTopOffset!: number;

  navBuffer = 100;

  get UILinks(): MobileNavUILink[] {
    return this.navLinks.map( (navLink, index) => {
        return {
            id: index,
            title: navLink.title.trim(),
            elementRef: navLink.elementRef,
            analyticsName: this.matchAnalyticsName(navLink.title),
        } as MobileNavUILink
    });
  }

  mounted() {    
    window.addEventListener('scroll', this.onMobileScroll);
  }

  destroyed() {
    window.removeEventListener('scroll', this.onMobileScroll);
  }

  onMobileScroll() {
    this.updateNavOnScroll(window.scrollY);
  }

  onMobileNavClick(e: Event, id: number) {
    e.preventDefault();
    this.$services.ui.scrolltToYPosition(this.navLinks[id].elementRef, this.navTopOffset - 2);
  }

  private updateNavOnScroll(scrollPos: number) {
    const scrollPosWithOffset = scrollPos + this.navTopOffset + this.navBuffer;
    for (let i = 0; i < this.navLinks.length; i++) {
        let positionFromTop = this.navLinks[i].elementRef.getBoundingClientRect().top + window.scrollY;
        if (positionFromTop <= scrollPosWithOffset) {
            this.selectNav(i);
        } else {
            break;
        }
    }
  }

  private selectNav(id: number) {
    const childList = (this.$refs.mobileNav as HTMLElement).children;
    for (const child of childList) {
      if(child.classList.contains('selected')) {
        child.classList.remove('selected')
      }
    }
    childList[id].classList.add('selected');
    childList[id].scrollIntoView({behavior: 'auto', block: 'end', inline: 'start'});
  }

  private matchAnalyticsName(title: string): string {
    let r = '';
    for (const analyticsName of AnalyticsNames) {
      if (analyticsName.exclude && analyticsName.exclude.some(s => title.toLowerCase().includes(s))) {
        continue;
      }
      if (analyticsName.subStrings.some(s => title.toLowerCase().includes(s))) {
        r = analyticsName.name;
      }
    }
    return r;
  }
}
